export enum LearningPathsOrderingAllEnum {
  Name = 'Name',
  Created = 'Created',
  ProgramYear = 'ProgramYear',
}
